import { render, staticRenderFns } from "./SpecialBetView.vue?vue&type=template&id=d65c46e8&"
import script from "./SpecialBetView.vue?vue&type=script&lang=js&"
export * from "./SpecialBetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports